import React from 'react';
import { Link } from 'react-router-dom';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';
import { useLanguage } from '../../contexts/LanguageContext';
import { t } from '../../translations/translations';
import { FAQ_ITEMS } from '../../data/mock';

export const FaqPreviewSection = () => {
  const { language } = useLanguage();

  return (
    <section className="py-20 bg-[#f5f2e8]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-medium text-gray-900 mb-4">{t(language, 'sections.commonQuestions')}</h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {FAQ_ITEMS.slice(0, 4).map((item) => (
            <AccordionItem key={item.qKey} value={item.qKey} className="bg-white border border-gray-200 rounded-lg px-6">
              <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-blue-900">
                {t(language, `faqPage.${item.qKey}`)}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600">
                {t(language, `faqPage.${item.aKey}`)}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="text-center mt-8">
          <Link to="/faq" className="text-blue-900 font-medium hover:underline">
            {t(language, 'sections.viewAllQuestions')}
          </Link>
        </div>
      </div>
    </section>
  );
};
